"use client";

import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import ISalesProduct from "@/interfaces/sales-product.interfaces";
import salesProductService from "@/services/sales-product.service";
import { ByIdRequestProps, RequestsBaseReturn } from "@/types/requests.types";

export type UseGetSalesProductByIdReturn = RequestsBaseReturn<ISalesProduct | null>;

export type IdProps = ByIdRequestProps;

type UseSwrGetSalesProductByIdParams = [string, number];

const useGetSalesProductById = ({ _id }: IdProps): UseGetSalesProductByIdReturn => {
  const fetcher = useSWR<ISalesProduct, Error, UseSwrGetSalesProductByIdParams | null>(
    _id ? [SWR_KEYS.getSalesProductById, _id] : null,
    ([, salesProductId]) => salesProductService.getById(salesProductId),
    { revalidateOnFocus: false }
  );

  const { data = null, isValidating: isLoading, error } = fetcher;

  return { data, isLoading, error };
};

export default useGetSalesProductById;
